import {
  CLEAR_CART_STATUS,
  FETCH_CART_STATUS,
  FETCH_CART_STATUS_FULFILLED,
  FETCH_CART_STATUS_REJECTED,
  REPLACE_CART_STATUS,
} from 'b2b-apps/shop/cart/redux/cartStatus/actionTypes';
import {
  ClearCartStatusAction,
  FetchCartStatusAction,
  FetchCartStatusFulfilledAction,
  FetchCartStatusRejectedAction,
  ReplaceCartStatusAction,
} from 'b2b-apps/shop/cart/redux/cartStatus/types';
import { CartStatusType } from 'b2b-common/core/cart/api/CartTypes';

const clearCartStatus = (): ClearCartStatusAction => ({
  type: CLEAR_CART_STATUS,
});

const fetchCartStatus = (): FetchCartStatusAction => ({
  type: FETCH_CART_STATUS,
});

const fetchCartStatusFulfilled = (
  data: CartStatusType,
): FetchCartStatusFulfilledAction => ({
  type: FETCH_CART_STATUS_FULFILLED,
  payload: {
    data,
  },
});

const fetchCartStatusRejected = (
  error: ErrorType,
): FetchCartStatusRejectedAction => ({
  type: FETCH_CART_STATUS_REJECTED,
  payload: {
    error,
  },
});

const replaceCartStatus = (data: CartStatusType): ReplaceCartStatusAction => ({
  type: REPLACE_CART_STATUS,
  payload: {
    data,
  },
});

export {
  clearCartStatus,
  fetchCartStatus,
  fetchCartStatusFulfilled,
  fetchCartStatusRejected,
  replaceCartStatus,
};
